document.addEventListener('DOMContentLoaded', function() {
  const container = document.getElementById('quantity-list');
  const addToCartButton = document.getElementById('add-to-cart-button');
  const variantId = container.dataset.variantId; // We'll need this added to HTML
  
  // Get selected quantity (either from pre-selected item or default to first item)
  function getSelectedQuantity() {
    const selectedItem = container.querySelector('.quantity-item.selected');
    return selectedItem ? parseInt(selectedItem.dataset.quantity) : 0;
  }

  // Step 1: Quantity Selection
  const quantityItems = document.querySelectorAll('.quantity-item');
  quantityItems.forEach(item => {
    item.addEventListener('click', function() {
      selectQuantityItem(this);
    });
  });

  function selectQuantityItem(item) {
    quantityItems.forEach(c => c.classList.remove('selected'));
    item.classList.add('selected');
  }

  // Add to Cart Button
  addToCartButton.addEventListener('click', function() {
    // Disable the button to prevent multiple clicks
    this.disabled = true;
    
    const quantity = getSelectedQuantity();
    
    if (!quantity || !variantId) {
      console.error('Missing required data: quantity or variant ID');
      this.disabled = false;
      return;
    }

    // Prepare the cart data
    const cartData = {
      items: [{
        id: variantId,
        quantity: quantity
      }]
    };
  
    // Use Shopify's AJAX API to add items to the cart
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(cartData)
    })
    .then(response => response.json())
    .then(data => {
      console.log('Items added to cart:', data);
      
      // Create and dispatch the ajaxProduct:added event
      const addedEvent = new CustomEvent('ajaxProduct:added', {
        detail: { items: data }
      });
      document.dispatchEvent(addedEvent);
      
      // Re-enable the button
      this.disabled = false;
    })
    .catch(error => {
      console.error('Error adding items to cart:', error);
      // Re-enable the button
      this.disabled = false;
      // Show an error message
      const errorEvent = new CustomEvent('cart:error', {
        detail: {
          error: error.description || 'There was an error adding items to your cart. Please try again.'
        }
      });
      document.dispatchEvent(errorEvent);
    });
  });
});